export const channelTitleFormatter = (sectionName) => `channel.${sectionName}.title`;
export const channelDescriptionFormatter = (sectionName) => `channel.${sectionName}.new-description`;
